import { PluginKey } from '@atlaskit/editor-prosemirror/state';

import type { AIDecorationExperiencePluginState } from './reducer';

export const aiExperienceDecorationPluginKey: PluginKey<AIDecorationExperiencePluginState> = new PluginKey<AIDecorationExperiencePluginState>(
	'aiExperienceDecoration',
);
